import { BLE } from '@ionic-native/ble';
import { createContext, useContext } from 'react';
import BluetoothLEService from './BLE';

export type BLEOriginal_ = typeof BLE;

const BluetoothContext = createContext<null | BluetoothLEService>(null);

export const BluetoothProvider = BluetoothContext.Provider;
export function useBluetoothService() {
  const svc = useContext(BluetoothContext);
  if (svc === null) {
    throw new Error(
      'BluetoothService cannot be null, please add a context provider'
    );
  }
  return svc;
}
